import { digitsMask } from './masks'

const passwordValidator = password => { 
  if (password.length < 8) {
    return '*A senha deve ter no mínimo 8 caracteres.';
  }

  if (password.length > 32) {
    return '*A senha deve ter no máximo 32 caracteres.';
  }

  if (!/[A-Z]/.test(password)) {
    return '*A senha deve ter pelo menos uma letra maiúscula.';
  }

  if (!/[a-z]/.test(password)) {
    return '*A senha deve ter pelo menos uma letra minúscula.';
  }

  if (!/[0-9]/.test(password)) {
    return '*A senha deve ter pelo menos um número.';
  }
  
  if (!/[^A-Za-z0-9]/.test(password)) {
    return '*A senha deve ter pelo menos um caractere especial.';
  }

  return true;
};

const emailValidator = email => {
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return false;
  }

  return true;
};

const cpfValidator = cpf => {
  cpf = digitsMask(cpf);

  let soma = 0;
  let resto;

  const cpfNumber = digitsMask(cpf);

  if (isNaN(cpfNumber)) {
    return {
      error: true,
      message: 'O CPF deve conter somente números.'
    }
  }

  if (cpfNumber.length !== 11) {
    return {
      error: true,
      message: `O CPF deve conter 11 dígitos`
    }
  }

  for (let i = 1; i <= 9; i++) {
    soma = soma + parseInt(cpfNumber.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
  }

  if (resto === 10 || resto === 11) {
    resto = 0;
  }

  if (resto !== parseInt(cpfNumber.substring(9, 10))) {
    return {
      error: true,
      message: 'O CPF é inválido.'
    }
  }

  soma = 0;

  for (let i = 1; i <= 10; i++) {
    soma = soma + parseInt(cpfNumber.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
  }

  if (resto === 10 || resto === 11) {
    resto = 0;
  }

  if (resto !== parseInt(cpfNumber.substring(10, 11))) {
    return {
      error: true,
      message: 'O CPF é inválido.'
    }
  }

  let cpfSequencial = [];

  for (let i = 0; i < 10; i++) {
    cpfSequencial.push(i.toString());
  }

  let cpfSeqArray = [];

  cpfSequencial.map(digit => {
    let cpfSeq = Array(11).fill(digit);
    cpfSeq = cpfSeq.join('');
    cpfSeqArray.push(cpfSeq);

    return cpfSeqArray;
  });
  
  if (cpfSeqArray.includes(cpf)) {
    return {
      error: true,
      message: 'O CPF não pode ser uma sequência de números.'
    }
  }

  return {
    error: false,
    message: ''
  }
};

const linkValidator = link => {
  return /^(http|https):\/\/.*\.pdf$/i.test(link);
};

const cnsValidator = cns => {
  cns = digitsMask(cns);

  if (cns.length !== 15) {
    return false;
  }

  const primeiroDigito = parseInt(cns.charAt(0), 10);

  if (primeiroDigito === 1 || primeiroDigito === 2) {
    let soma = 0;

    for (let i = 0; i < 11; i++) {
      soma += parseInt(cns.charAt(i), 10) * (15 - i);
    }

    const resto = soma % 11;
    let dv = 11 - resto;

    if (dv === 11) {
      dv = 0;
    }

    if (dv === 10) {
      let novaSoma = 0;

      for (let i = 0; i < 11; i++) {
        novaSoma += parseInt(cns.charAt(i), 10) * (15 - i);
      }

      dv = 11 - (novaSoma % 11);
    }

    const resultado = cns.slice(0, 11) + (dv < 10 ? '00' : '001') + dv;

    return cns === resultado;
  } else if (primeiroDigito === 7 || primeiroDigito === 8 || primeiroDigito === 9) {
    let soma = 0;

    for (let i = 0; i < 15; i++) {
      soma += parseInt(cns.charAt(i), 10) * (15 - i);
    }

    const resto = soma % 11;

    return resto === 0;
  } else {
    return false;
  }
};

export { passwordValidator, emailValidator, cpfValidator, linkValidator, cnsValidator };
